<template>
  <div v-if="banner" class="rounded-top-1 rounded-md-0" :style="`background-image: url(${banner});background-size: cover;background-position: center;height: 10rem;`">
    <img v-if="props.participation.travel.titleBanner?.key" :src="getPictureUrl(props.participation.travel.titleBanner.key)" style="max-width: 40%;max-height: 160px;" class="p-3" />
    <div v-if="true" style="width: 20rem;max-width: 50%;max-height: 150px;" class="float-end d-none d-md-block">
      <CountdownComponent :target-date="props.participation.travel.startDate" class="float-end m-2" />
    </div>
    <div v-else style="width: 16rem;max-width: 50%;max-height: 150px;" class="float-end d-none d-md-block">
      <CountdownComponentV2 :target-date="props.participation.travel.startDate" class="float-end m-2" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { getPictureUrl } from '@/compositions/helper';

  const props = defineProps<{
    participation: UserParticipation;
  }>();

  const banner = computed(() => {
    if (props.participation?.travel.mainPicture?.key) {
      return getPictureUrl(props.participation.travel.mainPicture.key);
    }

    return undefined;
  });
</script>
